import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../../basic-ui-components/icon/svg-icon/svg.icon';

export class PromotionsIcon extends React.Component<ISvgIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g fill="currentColor">
                    <path d="M13.022,3.509c-0.257-0.615-1.086-0.553-1.321,0.002
                        C10.864,5.477,9.226,7.214,7.444,8.61c-1.777,1.392-3.655,2.413-4.911,2.957c-0.374,0.162-0.536,0.607-0.356,0.974l1.911,3.907
                        c0.184,0.376,0.64,0.504,0.988,0.305c0.017-0.01,0.035-0.017,0.052-0.027c0.074,0.104,0.141,0.202,0.238,0.33
                        c0.296,0.389,0.704,0.896,1.155,1.444c0.904,1.098,1.996,2.379,2.757,3.259c0.218,0.252,0.575,0.313,0.862,0.161l2.745-1.459
                        c0.206-0.109,0.404-0.357,0.363-0.686c-0.083-0.664-0.696-1.716-2.259-2.859c-0.547-0.4-1.008-0.872-1.306-1.431l-0.137-0.257
                        c2.879-0.466,5.649-0.108,7.259,0.319c0.561,0.149,1.074-0.416,0.84-0.975L13.022,3.509z M8.792,15.969
                        c0.391,0.732,0.973,1.313,1.603,1.773c1.176,0.859,1.633,1.563,1.786,1.94l-2.299,1.222c-0.746-0.865-1.747-2.042-2.583-3.057
                        c-0.449-0.545-0.847-1.04-1.131-1.413c-0.048-0.063-0.086-0.115-0.126-0.169c0.804-0.366,1.633-0.638,2.464-0.832L8.792,15.969z
                        M9.038,14.279l-1.045-1.958c-0.132-0.248-0.439-0.341-0.684-0.207c-0.246,0.134-0.338,0.443-0.205,0.691L8.008,14.5
                        c-0.951,0.241-1.898,0.585-2.813,1.043c-0.09,0.02-0.173,0.057-0.238,0.118c-0.034,0.018-0.068,0.032-0.102,0.05l-1.632-3.337
                        c0.832-0.379,1.869-0.942,2.951-1.634l0.177,0.384c0.117,0.255,0.418,0.366,0.671,0.248c0.253-0.119,0.363-0.422,0.245-0.677
                        l-0.24-0.523C7.373,9.931,7.72,9.685,8.064,9.416c1.674-1.312,3.299-2.968,4.283-4.898l4.138,9.904
                        C14.681,14.024,11.904,13.753,9.038,14.279z"/>
                    <path d="M16.153,5.604c0.257,0.109,0.553-0.014,0.661-0.273
                        l1.089-2.625c0.108-0.26-0.013-0.559-0.271-0.667c-0.257-0.109-0.553,0.014-0.661,0.273l-1.089,2.625
                        C15.774,5.196,15.895,5.495,16.153,5.604z"/>
                    <path d="M21.588,11.409l-2.596-1.113
                        c-0.257-0.11-0.553,0.011-0.662,0.27c-0.109,0.259,0.011,0.559,0.268,0.669l2.595,1.113c0.257,0.11,0.553-0.011,0.663-0.27
                        C21.965,11.818,21.845,11.519,21.588,11.409z"/>
                    <path d="M20.856,6.521c-0.111-0.258-0.409-0.377-0.665-0.265
                        l-2.587,1.133c-0.256,0.112-0.373,0.412-0.262,0.671c0.111,0.258,0.409,0.377,0.664,0.265l2.587-1.133
                        C20.849,7.08,20.967,6.779,20.856,6.521z"/>
                </g>
            </SvgIcon>
        );
    }
}
